import { cn } from "@/lib/utils";
import { ProductImage } from "@/utils/elevate/getImageInfoFromProduct";
import Image from "next/image";
import { ComponentProps } from "react";

export default function ProductCardImageCarousel({
  images,
  className,
  ...props
}: { images: ProductImage[] } & ComponentProps<"div">) {
  // shortcut: Safari drops mix-blend-mode inside overflow-x-scroll. Filter multiplies by --color-primary-100. Remove when WebKit fixes it.
  const filterId = `m${images[0]?.id.replace(/[^a-zA-Z0-9]/g, "") ?? "x"}`;

  return (
    <div
      className={cn(
        "scrollbar-none bg-primary-100 relative flex h-full snap-x snap-mandatory items-start gap-px overflow-x-scroll",
        className,
      )}
      {...props}
    >
      <svg aria-hidden="true" className="absolute" width="0" height="0">
        <filter
          id={filterId}
          x="0"
          y="0"
          width="100%"
          height="100%"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="hsl(60 22% 96%)" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" mode="multiply" />
        </filter>
      </svg>
      {images.slice(0, 5).map((image) => (
        <Image
          key={image.id}
          src={image.src}
          alt={image.alt}
          width={400}
          height={500}
          className="h-full shrink-0 basis-full snap-start object-contain"
          style={{ filter: `url(#${filterId})` }}
        />
      ))}
    </div>
  );
}
